import { Component, EventEmitter, inject } from "@angular/core";
import { Subject } from "rxjs";
import { ReportDesignerCustomComponentInstance } from "src/app/modules/bootstrap/modules/report/report-designer/report-designer-custom-component-instance";
import { ReportDesignerItemCustom } from "src/app/modules/bootstrap/modules/report/report-design-item";
import { HealthRecordBackend } from "src/app/backend/api/health-record.backend";
import { HealthRecordAttachment } from "src/app/backend/models/health-record";

@Component({
  selector: "pms-soap-template-attachments",
  templateUrl: "soap-template-attachments.component.html",
  styles: [
    `
      :host {
        display: flex;
        flex: 1;
      }
    `
  ],
  standalone: false
})
export class SoapTemplateAttachmentsComponent implements ReportDesignerCustomComponentInstance {
  data$: Subject<any> = new Subject();
  action$: EventEmitter<string> = new EventEmitter<string>();

  attachments: HealthRecordAttachment[] | undefined;

  private healthRecordId: string | undefined;
  private readonly healthRecordBackend = inject(HealthRecordBackend);

  set item(value: ReportDesignerItemCustom) {
    this.healthRecordId = value.baseConfig.healthRecordId;
    this.attachments = value.baseConfig.attachments;
  }

  async onLinked(linkedEvent: {
    storageId: string;
    fileName: string;
    fileSize: number;
    fileType: string;
    callbackSetAttachmentId: (attachmentId: string) => void;
  }): Promise<void> {
    const attachment = await this.healthRecordBackend
      .addAttachment(this.healthRecordId!, {
        storageId: linkedEvent.storageId,
        name: linkedEvent.fileName,
        type: "unknown"
      })
      .toPromise();

    linkedEvent.callbackSetAttachmentId(attachment.id);

    this.data$.next(linkedEvent);
  }

  onUnlinked(attachmentId: string): void {
    this.data$.next(attachmentId);
  }

  async onRemoved(data: any): Promise<void> {
    if (data.file.id) {
      await this.healthRecordBackend.deleteAttachment(data.file.id).toPromise();
    }

    this.data$.next(data.file.id);
  }
}
